stripeUpdatePaymentMethod.$inject = ["API_URL", "$rootScope", "$http", "$filter", "$location", "$timeout"];
angular.module('directive.stripeupdatepaymentmethod', []).directive('stripeUpdatePaymentMethod', stripeUpdatePaymentMethod); // Update customer payment method.
// 1. The customer may simply want to update their payment card - not necessarily pay an invoice
// 2. They may need to complete SCA for an invoice.
//      - Immediately pay invoice
// 3. They may need to enter a new card to complete a failed payment.
//      - Immediately pay invoice

function stripeUpdatePaymentMethod(API_URL, $rootScope, $http, $filter, $location, $timeout) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/stripe-update-payment-method.html',
    scope: {},
    link: function link(scope, elem, attrs) {
      var stripeCard = null;
      var stripe = window.Stripe(smooth.stripePublicKey),
          elements = stripe.elements();

      scope.submitCard = function () {
        $rootScope.throbber.show();
        scope.processing = true; // Some payment methods and cards may require further authentication. In all cases
        // retrieve a payment intent from the server. If the transaction requires no further authentication
        // send back the payment intent ID to confirm the transaction.

        stripe.createToken(stripeCard).then(function (result) {
          $rootScope.throbber.hide();

          if (result.error) {
            scope.processing = false;
            scope.stripeError = result.error.message;
            return $rootScope.safeApply();
          }

          tryUpdate(result.token);
        });
      };

      var init = function init() {
        stripeCard = elements.create('card');
        stripeCard.mount('#update-payment-card-element');
        stripeCard.addEventListener('change', function (event) {
          var displayError = document.getElementById('card-errors');

          if (event.error) {
            scope.stripeError = event.error.message;
          } else {
            scope.stripeError = '';
          }

          $rootScope.safeApply();
        });
      };

      init();

      var tryUpdate = function tryUpdate(stripetoken) {
        var params = {
          stripetoken: stripetoken
        };
        $http.put(API_URL + '/api/v1/calendar/membership/payments/update-card', params).then(function (reply) {
          $rootScope.throbber.hide();
          scope.processing = false;
          var response = reply.data;

          if (!response.success) {
            scope.stripeError = "Sorry but an error occurred: ".concat(response.msg);
            $timeout(function () {
              scope.stripeError = '';
            }, 3000);
            return;
          }

          scope.stripeSuccess = 'Your Stripe card has been successfully updated.';
          $rootScope.safeApply();
          $timeout(function () {
            scope.stripeSuccess = '';
          }, 3000);
        }).catch(function (error) {
          console.error(error.message);
          scope.stripeError = "Sorry but an error occurred - unhandled status: ".concat(response.status);
          $timeout(function () {
            scope.stripeError = '';
          }, 3000);
          scope.processing = false;
        });
      };

      var handleSCA = function handleSCA(clientSecret) {
        $rootScope.throbber.show();
        scope.processing = true;
        stripe.handleCardPayment(clientSecret, stripeCard).then(function (response) {
          if (response.error) {
            scope.stripeError = "".concat(response.error.message);
            $timeout(function () {
              scope.stripeError = '';
            }, 3000);
            $rootScope.safeApply();
            return;
          }

          scope.processing = false;
          $rootScope.throbber.hide();
          scope.stripeSuccess = 'You have successfully verified your payment card. Please wait, you will be redirected.';
          $rootScope.safeApply();
          $timeout(function () {
            scope.stripeSuccess = '';
            $location.path('/');
          }, 3000);
        }).catch(function (err) {
          console.error(err);
          scope.stripeError = 'Sorry but an error occurred:' + err.msg;
          $timeout(function () {
            scope.stripeError = '';
          }, 3000);
        });
      };

      var tryPaymentOld = function tryPaymentOld(paymentMethodID) {
        var paymentIntentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var params = {
          membership: scope.membership,
          plan: scope.plan
        };

        if (paymentMethodID) {
          params.payment_method_id = paymentMethodID;
        }

        if (paymentIntentId) {
          params.payment_intent_id = paymentIntentId;
        }

        return new Promise(function (resolve, reject) {
          // The payment method may require additional authentication (or not).
          // If it doesn't the transaction will complete. If it does, Stripe will
          // take the user through the additional steps and then the client will reply
          // to the server again with a payment intent for confirmation.
          $http.post(API_URL + '/api/v1/calendar/membership/create', params).then(function (reply) {
            $rootScope.throbber.hide();
            scope.processing = false;
            var response = reply.data;

            if (response.success && !response.requiresaction) {
              return scope.success(response.appointments);
            }

            if (!response.success) {
              return $rootScope.throbber.showError(response.msg);
            }

            if (response.requiresaction) {
              $rootScope.throbber.show();
              scope.processing = true;
              stripe.handleCardAction(response.intentsecret).then(function (result) {
                scope.processing = true;

                if (result.error) {
                  return $rootScope.throbber.showError(result.error.message);
                }

                $rootScope.throbber.show();
                scope.tryPayment(null, result.paymentIntent.id);
                resolve();
              });
              return;
            }

            console.error(response);
            alert('unhandled response');
          }).catch(function (error) {
            console.error(error.message);
            $rootScope.throbber.showError("Sorry but an error occurred with this request: ".concat(error.message));
            scope.processing = false;
          });
        });
      };
    }
  };
}